<script>
import { authComputed } from '@state/helpers'
import { eventColorsMixin } from '@src/mixins/eventColorsMixin'

export default {
  mixins: [eventColorsMixin],
  props: {
    selectedEventTypeProp: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      calendarCheckboxShow: false,
      selectedEventType: this.selectedEventTypeProp,
    }
  },
  computed: {
    ...authComputed,

    getEventTypes() {
      const publicEvents = [
        'Network Event',
        'Industry Events',
        'Prof. Development/Education',
        'Support Closure',
        'Onboarding and Implementation',
      ]
      const internalEvents = ['Internal Event', 'Communication Calendar']

      if (this.isMottoCorporate) {
        return [...publicEvents, ...internalEvents]
      }
      return publicEvents
    },
  },
  watch: {
    selectedEventType: {
      handler: function () {
        this.$emit('update:selected-event-type-prop', this.selectedEventType)
      },
    },
  },
  mounted() {
    document.addEventListener('click', this.handlePageClick)
  },
  methods: {
    hideCalendarCheckbox() {
      this.calendarCheckboxShow = false
    },

    shouldHideCalendarCheckbox(clickEvent) {
      if (!this.calendarCheckboxShow) {
        return false
      }

      const elemTree = clickEvent.composedPath()

      const isInsideDiv = elemTree.some((node) => {
        try {
          return node?.getAttribute('id') === 'select-event-type'
        } catch (err) {
          return false
        }
      })

      return !isInsideDiv
    },

    handlePageClick(evt) {
      if (this.shouldHideCalendarCheckbox(evt)) {
        this.hideCalendarCheckbox()
      }
    },
  },
}
</script>

<template>
  <div id="select-event-type">
    <div class="position-relative">
      <div
        :class="[$style.eventDivSelect, disabled ? $style.disabled : null]"
        @click="calendarCheckboxShow = !calendarCheckboxShow">
        <span v-if="!selectedEventType.length">All Event Types</span>
        <span v-if="selectedEventType.length === 1">{{ selectedEventType[0] }}</span>
        <span v-if="selectedEventType.length > 1">{{ selectedEventType.length }} Event Types Selected</span>
      </div>
      <BaseIcon name="chevron-down" :class="$style.eventDivSelectDownArrow" />
    </div>
    <div v-show="calendarCheckboxShow" :class="$style.calendarCheckbox">
      <div v-for="eventType in getEventTypes" :key="eventType" :class="$style.calendarCheckboxItem">
        <label :class="$style.container">
          <span>{{ eventType }}</span>
          <input v-model="selectedEventType" type="checkbox" :value="eventType" />
          <span :class="{ [$style.checkmark]: true, [getEventColorClass(eventType)]: true }"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.eventDivSelect {
  flex: 0 0 150px;
  width: 250px;
  height: 30px;
  padding: 5px 20px 5px 16px;
  font-size: 14px;
  color: $dark-gray;
  cursor: pointer;
  background-color: $white;
  border: 0.5px $primary-blue solid;
  border-radius: 36px;
  outline: none;
  appearance: none;
}

.eventDivSelectDownArrow {
  position: absolute;
  top: 9px;
  right: 8px;
  width: 0.7em !important;
  color: $gray;
  pointer-events: none;
}

.calendarCheckbox {
  position: absolute;
  z-index: 2;
  width: 250px;
  overflow: hidden;
  background-color: white;
  border: solid 1px $light-gray;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 $gray;
}

.calendarCheckboxItem {
  display: flex;
  align-items: center;
  height: 28px;
}

.calendarCheckboxItem:hover {
  background-color: $lightest-gray;
}

.container {
  position: relative;
  display: block;
  width: 100%;
  padding: 8px 0 0 40px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    width: 0;
    height: 0;
    cursor: pointer;
    opacity: 0;
  }
}

.checkmark {
  position: absolute;
  top: 7px;
  left: 14px;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.container:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkmark::after {
  position: absolute;
  display: none;
  content: '';
}

.container .checkmark::after {
  top: 1px;
  left: 6px;
  width: 8px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.container input:checked ~ .checkmark::after {
  display: block;
}

.disabled {
  opacity: 0.7;
}
</style>
